import images from "../assets/loaders/imageLoader"

const ErrorPage = () => {
  return (
    <div className="bg-neutral flex items-center justify-center h-screen">
      <div className="prose lg:prose-md bg-warning p-8 rounded-b-xl rounded-t-xl shadow text-center">
        <img
          src={images.logoComplete}
          alt="logo"
          className="mb-5 w-64 inline-block"
        />
        <h4 className="text-warning-content">Oops! Ha ocurrido un error</h4>
        <p className="text-warning-content">
          Vuelve a la página principal y vuelve a intentarlo
        </p>
        <div onClick={() => window.history.back()} className="btn btn-secondary">
          Volver
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
